import { Text } from "@/components/ui/text";
import { View } from "@/components/ui/view";
import { Pressable } from "@/components/ui/pressable";
import { Image } from "@/components/ui/image";
import { Center } from "@/components/ui/center";
import React, { useState } from 'react';
import i18n from "@/assets/i18n";
import loadingImg from "@/assets/images/loading.png";
import { IconM } from '@/components/media/IconsV2';
import ModalMedia from '@/components/basic/ModalMedia';
import * as MediaSelector from "@/components/media/MediaSelector";
import { ResizeMode, Video } from 'expo-av';
import { useWindowDimensions } from 'react-native';
import MediaDraw from '@/components/media/MediaDraw';

export default function WebMedia(props) {
    const [imgSrc, setImgSrc] = useState(props.uri)
    const [showModal, setShowModal] = useState(false)
    const [overlay, setOverlay] = useState(props.overlay || []);
    const dim = useWindowDimensions()
    const LIGHTBOX_SIZE = Math.min(7, Math.floor((dim.height - 100) / 100))

    const onLoad = () => { }

    const onError = () => {
        console.log('Media loading', props.uri)
        setImgSrc(loadingImg)
    }

    const closeModal = () => {
        setShowModal(false)
        if (props.updateOverlay) {
            // fix path for firefox usage
            props.updateOverlay(props.id, overlay.map(elem => {
                if (elem.tag == 'Path') {
                    elem.attrs.d = elem.attrs.d.replace(/,/g,' ')
                }
                return elem
            }))
        }
    }

    return (
        <Center className={` ${props.className} ${props.index === 0 ? "ml-[0px]" : "ml-[4px]"} bg-primary-50 `}>
            <Pressable onPress={() => setShowModal(true)}>
                {MediaSelector.isMedia(props.id) ?
                    <Video key={imgSrc} source={imgSrc} style={{ justifyContent: 'center', width: props.size, height: props.size }} useNativeControls={false} resizeMode={ResizeMode.COVER} onReadyForDisplay={videoData => {
                        videoData.srcElement.style.position = 'unset'
                    }} />
                    :
                    <Image source={imgSrc} resizeMode='contain' onLoad={onLoad} onError={onError} alt={i18n.t('global.missingImage')} className={` width-${props.size} height-${props.size} `} />
                }
                <MediaDraw size={props.size} overlay={overlay}/>
            </Pressable>
            {props.deleteMedia && <View className="absolute top-0 right-0 bg-[#FFFFFF80] border border-primary-900 rounded-[4px]">
                <IconM className='text-primary-900' size={20} name='delete' />
                <Pressable onPress={() => props.deleteMedia(props.index)} className="absolute w-8 h-8" />
            </View>}
            <ModalMedia showModal={showModal} closeModal={closeModal} isVideo={MediaSelector.isMedia(props.id)} imgSrc={imgSrc} size={LIGHTBOX_SIZE} overlay={overlay} setOverlay={setOverlay} disabled={props.disabled} />
        </Center>
    );
}
